//PanelContentTabService
(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-select-panel-content-tab', actionFunc);

    function actionFunc($q, lodash, PanelContentTabService) {
        return function(panel, options, eventData, actionData) {
            return $q.when(run());

            function run() {
                const combinedData = (options.useActionResponse)
                    ? angular.merge(angular.copy(options), actionData.data)
                    : angular.merge(angular.copy(options), eventData);
                const identifier = lodash.get(options, 'identifier', null);
                const active_identifier = lodash.get(combinedData, 'panel_content_identifier', null);
                if (identifier === null || active_identifier === null) {
                    return false;
                }

                PanelContentTabService.setActive(identifier, active_identifier);
            }
        };
    }
})();